import { CONFIG_PROVIDER, getPrefixCls } from '@ss/mtd-vue/es/utils/config';

var __vue_render__ = function __vue_render__() {
  var _obj;
  var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { ref: "item", class: [_vm.prefix, _vm.prefix + "-" + _vm.index, (_obj = {}, _obj[_vm.prefix + "-active"] = _vm.activeIndex === _vm.index, _obj[_vm.carouselPrefix + "-fake-item"] = _vm.fake, _obj)], style: _vm.itemStyle }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__ = [];

export default {
  render: __vue_render__,

  staticRenderFns: __vue_staticRenderFns__,

  name: 'MtdCarouselItem',
  props: {
    index: Number,
    activeIndex: Number,
    width: Number,
    height: Number,
    fake: {
      type: Boolean,
      default: false
    }
  },
  inject: {
    config: {
      from: CONFIG_PROVIDER,
      default: {
        getPrefixCls: getPrefixCls
      }
    }
  },
  computed: {
    prefix: function prefix() {
      return this.config.getPrefixCls('carousel-item');
    },
    carouselPrefix: function carouselPrefix() {
      return this.config.getPrefixCls('carousel');
    },
    itemStyle: function itemStyle() {
      var width = this.width,
          height = this.height;

      return {
        width: width ? width + 'px' : '',
        height: height ? height + 'px' : ''
      };
    }
  }
};